import { AppText } from "~/ui/app-text"
import { PhoneNumberInput } from "~/ui/phone-number/phone-number-input"
import type { PhoneNumberValue } from "~/common/phone-number"
import type { ShareRoomMemberFragment } from "~/__generated__/graphql"
import React from "react"
import { ArrowRight, LockSimple } from "phosphor-react"

interface JoinBarProps {
  inviterData: ShareRoomMemberFragment | null
  phoneNumberValue: PhoneNumberValue
  setPhoneNumberValue: (value: PhoneNumberValue) => void
  handleJoinRoom: () => void
  handleManualFocus: (e: React.MouseEvent) => void
  phoneInputRef: React.RefObject<HTMLInputElement>
}

export const JoinBar = ({
  inviterData,
  phoneNumberValue,
  setPhoneNumberValue,
  handleJoinRoom,
  handleManualFocus,
  phoneInputRef,
}: JoinBarProps) => {
  return (
    <>
      {inviterData && inviterData.displayOrUsername && (
        <div className="flex items-center justify-center gap-2 pt-3">
          <AppText variant="body3-medium" className="text-base-white md:text-15 md:tracking-n1-5">
            {inviterData.shortDisplayName} invited you to skip the waitlist
            <span>&nbsp;&nbsp;🎉</span>
          </AppText>
        </div>
      )}
      <div className="m-2 mx-auto flex max-w-[360px] items-center gap-[11px] rounded-full border border-base-black bg-base-white p-2">
        <div className="flex-1" onClick={handleManualFocus}>
          <PhoneNumberInput
            ref={phoneInputRef}
            value={phoneNumberValue}
            onChange={setPhoneNumberValue}
            onSubmit={handleJoinRoom}
            inputClassName="max-w-[320px]"
          />
        </div>
        <button
          onClick={handleJoinRoom}
          className="flex h-[48px] w-[48px] items-center justify-center rounded-full border border-base-black bg-base-yellow"
        >
          <AppText variant="h2" className="uppercase text-base-black">
            <ArrowRight size={24} weight="bold" />
          </AppText>
        </button>
      </div>
      <div className="flex items-center justify-center pb-3">
        <LockSimple size={16} weight="fill" className="text-base-white opacity-50" />
        <AppText
          variant="body3-medium"
          className="text-base-white opacity-50 md:text-15 md:tracking-n1-5"
        >
          &nbsp;We'll text you a link. Your # is kept private.
        </AppText>
      </div>
    </>
  )
}
